import React from "react";
import styles from "./SlideBar.module.css";

type SliderBarProps = {
  label?: string;
  value?: number;
  onChange?: (value: number) => void;
  min?: number;
  max?: number;
  leftLabel?: string;
  rightLabel?: string;
  customClass?: string;
  style?: React.CSSProperties;
  scale?: boolean;
  customLabel?: boolean;
  disabled?: boolean;
  onClick?: (value: number) => void;
};

const SlideBar: React.FC<SliderBarProps> = ({
  label,
  value,
  onChange,
  onClick,
  min = 0,
  max = 10,
  leftLabel = "No Pain (0)",
  rightLabel = "Worst Pain (10)",
  customClass = "",
  style,
  scale,
  customLabel,
}) => {
  return (
    <div className={`${styles.wrapper} ${customClass}`} style={style}>
      <p className={styles.label}>
        {label}
        {scale && (
          <span className={styles.scale}>
            ({min}-{max} scale)
          </span>
        )}
      </p>
      <div className={styles.rangeWrapper}>
        <input
          type="range"
          min={min}
          max={max}
          value={value}
          onChange={(e) => onChange?.(Number(e.target.value))}
          onClick={(e) => onClick?.(Number(value ? value : 0))}
          className={styles.rangeInput}
        />
        <div className={styles.tickLabels} style={{ marginTop: "0.75rem" }}>
          {Array.from({ length: max - min + 1 }, (_, i) => (
            <span key={i} className={styles.tickLabel}>
              {i + min}
            </span>
          ))}
        </div>
      </div>
      {customLabel && (
        <div className={styles.rangeLabels}>
          <span>{leftLabel}</span>
          <span>{rightLabel}</span>
        </div>
      )}
    </div>
  );
};

export default SlideBar;
